import { takeLatest, select, call, put } from "redux-saga/effects";
import axios from "axios";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";
import {
	requestDefaultJson,
	callbackStatusDefault,
	callbackDataDefault,
	callbackResolveDefault
} from './helpers'

const getGateVariationsFromApi = (id, token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/variacao/" + id, {
			method: "GET",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
				"Content-Type": "application/json",
				"Authorization": token
			},
		})
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				const response = error.response.data
				reject(response);
				log.info(error);
			});
	});
};

const getLastDateFromApi = (token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/variacao/maiorData", {
			method: "GET",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
				"Content-Type": "application/json",
				"Authorization": token
			},
		})
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				const response = error.response.data
				reject(response);
				log.info(error);
			});
	});
};

const saveGateVariationsFromApi = (data, token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/variacao/", {
			method: "POST",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
				"Content-Type": "application/json",
				"Authorization": token
			},
			data
		})
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				const response = error.response.data
				reject(response);
				log.info(error);
			});
	});
};

const updateGateVariationsFromApi = (data, idVariacaoPortao, token) => {
	return new Promise((resolve, reject) => {
		return axios.request(getEnvParam("REACT_APP_BFF_URL_REST") + "/variacao/" + idVariacaoPortao, {
			method: "PUT",
			headers: {
				"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
				"Content-Type": "application/json",
				"Authorization": token
			},
			data
		})
			.then(response => response.status !== 200 ? reject(response) : response)
			.then(response => response.data)
			.then(response => resolve(response))
			.catch(error => {
				const response = error.response.data
				reject(response);
				log.info(error);
			});
	});
};

const deleteGateVariationFromApi = (idPortao, token) => {
	return requestDefaultJson({
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + "/variacao/" + idPortao,
		method: "DELETE",
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_CD"),
			"Authorization": token,
		}
	},
		callbackStatusDefault,
		callbackDataDefault,
		callbackResolveDefault,
		(resolve, reject) => error => {
			const response = error.response.data
			reject(response);
			log.info(error);
		});
};

//generators
function* getGateVariation(payload) {
	try {
		const authentication = state => state.authentication;

		const { token } = yield select(authentication);

		const data = yield call(getGateVariationsFromApi, payload.id, token);

		yield put({ type: "GATE_VARIATION", payload: data });

	} catch (error) {
		yield put({ type: "SET_GATE_VARIATION_ERROR", payload: { error: true, data: error } });

		log.info(error);
	}

}

//generators
function* getLastDate() {
	try {
		const authentication = state => state.authentication;

		const { token } = yield select(authentication);

		const data = yield call(getLastDateFromApi, token);

		yield put({ type: "SET_LAST_DATE", payload: data });

	} catch (error) {
		yield put({ type: "SET_GATE_VARIATION_ERROR", payload: { error: true, data: error } });

		log.info(error);
	}

}

function* saveGateVariation(payload) {
	try {
		const authentication = state => state.authentication;

		const { token } = yield select(authentication);

		const data = yield call(saveGateVariationsFromApi, payload.data, token);

		yield put({ type: "GET_GATE_VARIATION", id: data.idPortao });

		yield put({ type: "SET_GATE_VARIATION_SUCCESS", payload: { success: true, type: "save" } });

	} catch (error) {

		yield put({ type: "GET_GATE_VARIATION", id: payload.data.idPortao });

		yield put({ type: "SET_GATE_VARIATION_ERROR", payload: { error: true, data: error } });

		log.info(error);
	}
}


function* updateGateVariation(payload) {
	try {
		const { token } = yield select(state => state.authentication);

		yield call(updateGateVariationsFromApi, payload.data, payload.data.id, token);

		yield put({ type: "GET_GATE_VARIATION", id: payload.data.idPortao });

		yield put({ type: "SET_GATE_VARIATION_SUCCESS", payload: { success: true, type: "update" } });

	} catch (error) {

		yield put({ type: "GET_GATE_VARIATION", id: payload.data.idPortao });

		yield put({ type: "SET_GATE_VARIATION_ERROR", payload: { error: true, data: error } });

		log.info(error);
	}
}

function* deleteGateVariation({ payload }) {
	const idGate = yield select(state => state.gateVariations.idGate);
	try {
		const { token } = yield select(state => state.authentication);

		yield call(deleteGateVariationFromApi, payload.id, token);

		yield put({ type: "SET_GATE_VARIATION_SUCCESS", payload: { success: true, type: "delete" } });

		yield put({ type: "GET_GATE_VARIATION", id: idGate });


	} catch (error) {

		yield put({ type: "GET_GATE_VARIATION", id: idGate });
		console.log({ error });

		yield put({ type: "SET_GATE_VARIATION_ERROR", payload: { error: true, data: error } });

		log.info(error);
	}
}

// //Generator function
export function* getGateVariationWatcher() {
	yield takeLatest("GET_GATE_VARIATION", getGateVariation);
	yield takeLatest("GET_LAST_DATE", getLastDate);
	yield takeLatest("SAVE_GATE_VARIATION", saveGateVariation);
	yield takeLatest("UPDATE_GATE_VARIATION", updateGateVariation);
	yield takeLatest("DELETE_GATE_VARIATION", deleteGateVariation);
}